@use 'config';
@use '~@cewe-designsystem-stylecomponents/button';

:host {
  display: block;
  color: config.$partner-wizard-base-font-color;
  font-family: config.$partner-wizard-base-font-family;

  .button {
    @include button.button;
    @include button.button--basic;
    @include button.button-strong--on-light;

    max-width: 50rem;
  }
}
